import { Popup } from '../../../../../ui/popup/popup';

interface IReferCreditPopup {
    close: Function;
}

const ReferCreditPopup = (props: IReferCreditPopup) => {

    const { close } = props;

    const closePopup = () => {
        close();
    };

    return (
        <Popup width="400px" height="270px" close={ closePopup }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mb-2 text-xl">Redeem Your Rewards</p>
                <p className="mb-4 px-6">
                    Apply rewards to software purchases or subscriptions. These rewards were added to your account when your friends made a purchase via your referral link.<br/>
                    <a href="/legal/waves-refer-a-friend-program-terms-conditions">See terms & conditions</a>.</p>

                <button
                    type="button"
                    className="w-btn"
                    onClick={ closePopup }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default ReferCreditPopup;